import React from 'react'
import { ShippingOptionsButton } from './buttons/ShippingOptionsButton'
import { BackButton } from './buttons/BackButton'
import { ShippingRateButton } from './buttons/ShippingRateButton'
import { OrderStatusEnum } from '@ztechapps/common.contract'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { ButtonGroup } from 'react-bootstrap'
import { useCheckoutContext } from './index'
import { useOrderDocument } from './hooks/useOrderDocument'
import { MinimumOrderAmountNote } from './MinimumOrderAmountNote'

export const BottomActions = () => {
  const context = useCheckoutContext()
  const [activePanel] = context.activePanel
  const checkoutSteps = context.checkoutSteps
  return (
    <HorizontalStack className="justify-content-between">
      {checkoutSteps.map(({ bottomAction: BottomAction, itemKey }) => (
        <React.Fragment key={itemKey}>
          <ShowIf condition={activePanel === itemKey}>{<BottomAction />}</ShowIf>
        </React.Fragment>
      ))}
    </HorizontalStack>
  )
}

export const ItemBottomActions = () => {
  const { components, canOrder, isBelowMinimumOrderAmount } = useCheckoutContext()
  const { document } = useOrderDocument()

  return (
    <React.Fragment>
      <components.cancelCheckoutButton />

      <ButtonGroup>
        {/*Show the confirmButtonBottomActions also when the status is Quotation*/}
        <ShowIf
          condition={document?.status === OrderStatusEnum.InCart || document?.status === OrderStatusEnum.Quotation}
        >
          <components.confirmOrderButton />
        </ShowIf>

        <ShowIf condition={canOrder && !isBelowMinimumOrderAmount}>
          <ShippingOptionsButton />
        </ShowIf>
      </ButtonGroup>

      <ShowIf condition={!!isBelowMinimumOrderAmount}>
        <MinimumOrderAmountNote />
      </ShowIf>
    </React.Fragment>
  )
}

export const ShippingOptionsBottomActions = () => {
  return (
    <React.Fragment>
      <div>
        <BackButton />
      </div>
      <div>
        <ShippingRateButton />
      </div>
    </React.Fragment>
  )
}

export const ShippingRateBottomActions = () => {
  const { components } = useCheckoutContext()

  return (
    <React.Fragment>
      <div>
        <BackButton />
      </div>
      <div>
        <components.paymentMethodButton />
      </div>
    </React.Fragment>
  )
}

export const PaymentMethodBottomActions = () => {
  const { components } = useCheckoutContext()

  return (
    <React.Fragment>
      <div>
        <BackButton />
      </div>
      <div>
        <components.paymentButton />
      </div>
    </React.Fragment>
  )
}
